import React, { Suspense } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import { Heading } from '@eluve/components';
import { FilterableAppointmentsTable } from '@eluve/frontend-feature-appointment';

export const AdminAppointmentsDash: React.FC = () => {
  return (
    <div>
      <Heading size="2xl" className="pb-2">
        Appointments
      </Heading>
      <Suspense fallback={<TableSkeleton rowCount={20} />}>
        <FilterableAppointmentsTable isAdmin enableRowSelection />
      </Suspense>
    </div>
  );
};
